<template>
    <v-container>
        <v-flex class="text-center">
            <v-card class="pa-4">
                <v-icon class="icon-big mt-12 mb-12" color="success">lnr-checkmark-circle</v-icon>
                <h1>Sua sessão foi encerrada com sucesso!</h1>
                <br>
            </v-card>
        </v-flex>
    </v-container>
</template>

  <script>
  export default {
    name: 'LogoutSuccess',
    created () {
      window.history.pushState(null, null, window.location.href)
      window.addEventListener('popstate', this.handleBackNavigation)
    },
    beforeDestroy () {
      window.removeEventListener('popstate', this.handleBackNavigation)
    },
    methods: {
      handleBackNavigation (event) {
        window.history.pushState(null, null, window.location.href)
      }
    }
  }
  </script>
